import { Scope } from '@/constants/lookups';
import { OrderTransaction } from '@/components/~advisor/Trading/Trading/TradingForm';
import { PositionWithExtraInfo } from '@orbis-systems/orbis-api-middleware';

import {
    dismissQuoteSummary,
    setSelectedBaseCurrency,
    showQuoteSummary,
    toggleCrm,
    toggleSidebar,
    toggleSidebarView,
    setPreSelectedAlocation,
    clearPreSelectedAlocation,
} from '@oneview/redux/misc/miscActions';
import { createReducer } from '@reduxjs/toolkit';

export type PreSelectedAlocationType = {
    origin: { scope: Scope; id: number | null } | null;
    orderTransaction: OrderTransaction;
    position: PositionWithExtraInfo;
} | null;

export const MISC_REDUCER_DEFAULT_STATE: {
    crmOpened: boolean;
    sidebarOpened: boolean;
    sidebarPermanent: boolean;
    quoteSummarySymbol: string;
    selectedBaseCurrency: string;
    preSelectedAlocation: PreSelectedAlocationType;
} = {
    crmOpened: false,
    sidebarOpened: false,
    sidebarPermanent: true,
    quoteSummarySymbol: '',
    selectedBaseCurrency: '',
    preSelectedAlocation: null,
};

export const miscReducer = createReducer(MISC_REDUCER_DEFAULT_STATE, (builder) => {
    builder.addCase(toggleCrm, (state) => {
        state.crmOpened = !state.crmOpened;
    });
    builder.addCase(toggleSidebar, (state) => {
        state.sidebarOpened = !state.sidebarOpened;
    });
    builder.addCase(toggleSidebarView, (state) => {
        state.sidebarPermanent = !state.sidebarPermanent;
    });
    builder.addCase(showQuoteSummary, (state, action) => {
        state.quoteSummarySymbol = action.payload;
    });
    builder.addCase(setSelectedBaseCurrency, (state, action) => {
        state.selectedBaseCurrency = action.payload;
    });
    builder.addCase(dismissQuoteSummary, (state) => {
        state.quoteSummarySymbol = '';
    });
    builder.addCase(setPreSelectedAlocation, (state, action) => {
        state.preSelectedAlocation = action.payload;
    });
    builder.addCase(clearPreSelectedAlocation, (state) => {
        state.preSelectedAlocation = null;
    });
});
